import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import api from '../../../services/api';

const COLORS = ['#3b82f6', '#ec4899'];
const AGE_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'];

export default function PatientDemographics() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const response = await api.get('/dashboard/analytics/demographics/');
      setData(response.data);
    } catch (error) {
      console.error('Error loading demographics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center items-center h-64"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div></div>;
  }

  if (!data) return null;

  const genderData = [
    { name: 'Hommes', value: data.gender_distribution?.male || 0 },
    { name: 'Femmes', value: data.gender_distribution?.female || 0 }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Répartition par Âge</h3>
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data.age_distribution}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="range" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" name="Nombre de patients">
                {data.age_distribution?.map((entry: any, index: number) => (
                  <Cell key={`cell-${index}`} fill={AGE_COLORS[index % AGE_COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Répartition par Sexe</h3>
          <div className="flex flex-col items-center">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={genderData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  outerRadius={100}
                  dataKey="value"
                >
                  {genderData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <div className="mt-4 grid grid-cols-2 gap-8 text-center">
              <div>
                <div className="text-2xl font-bold text-blue-600">{data.gender_distribution?.male || 0}</div>
                <div className="text-sm text-gray-600">Hommes ({data.gender_distribution?.male_percentage?.toFixed(1)}%)</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-pink-600">{data.gender_distribution?.female || 0}</div>
                <div className="text-sm text-gray-600">Femmes ({data.gender_distribution?.female_percentage?.toFixed(1)}%)</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
